<ng-container *transloco="let t; prefix: 'side-nav'">

  @let sideNavVisible = navService.sideNavVisibilitySignal();
  @let sideNavCollapsed = navService.sideNavCollapsedSignal();

  @if (accountService.currentUser()) {
    <div class="side-nav-container"
         [class.no-donate]="licenseService.hasValidLicense()"
         [class.closed]="sideNavCollapsed"
         [class.hidden]="!sideNavVisible">
      <div class="side-nav" cdkDropList (cdkDropListDropped)="reorderDrop($event)" [cdkDropListDisabled]="accountService.hasReadOnlyRole()">


        <app-side-nav-item cdkDrag cdkDragDisabled icon="fa-home" [title]="t('home')" link="/home/">
          <ng-container actions>
            <app-card-actionables [actions]="homeActions" labelBy="home" iconClass="fa-ellipsis-v" (actionHandler)="performHomeAction($event)" />
          </ng-container>
        </app-side-nav-item>

        @if (navStreams$ | async; as streams) {
          @if (showAll) {
            <app-side-nav-item cdkDrag cdkDragDisabled icon="fa fa-chevron-left"
                               [title]="t(editMode ? 'cancel-edit' : 'back')" (click)="showLess()" />
            @if (!isReadOnly()) {
              <app-side-nav-item cdkDrag cdkDragDisabled icon="fa-cogs"
                                 [title]="t('customize')" link="/settings"
                                 [fragment]="SettingsTabId.Customize" />
            }
            @if (streams.length > ItemLimit && !sideNavCollapsed && !editMode) {
              <div cdkDrag cdkDragDisabled class="mb-2 mt-3 ms-2 me-2">
                <label for="filter" class="form-label visually-hidden">{{t('filter-label')}}</label>
                <div class="form-group position-relative">
                  <input id="filter" autocomplete="off" class="form-control" [(ngModel)]="filterQuery" type="text" aria-describedby="reset-input">
                  <button type="button" [attr.aria-label]="t('clear')" class="btn-close" id="reset-input" (click)="filterQuery = '';"></button>
                </div>
              </div>
            }

          }

          @for (navStream of streams | filter: filterLibrary; track navStream.name + navStream.order) {
            @switch (navStream.streamType) {
              @case (SideNavStreamType.Library) {
                <app-side-nav-item cdkDrag cdkDragBoundary=".side-nav-container" cdkDragPreviewContainer="parent"
                                   [cdkDragDisabled]="!editMode" [cdkDragData]="navStream" [editMode]="editMode"
                                   [link]="'/library/' + navStream.libraryId + '/'"
                                   [icon]="getLibraryTypeIcon(navStream.library!.type)"
                                   [imageUrl]="getLibraryImage(navStream.library!)" [title]="navStream.library!.name"
                                   [comparisonMethod]="'startsWith'">
                  <ng-container actions>
                    <app-card-actionables [entity]="navStream.library" [actions]="actions" [labelBy]="navStream.name" iconClass="fa-ellipsis-v" />
                  </ng-container>
                </app-side-nav-item>
              }

              @case (SideNavStreamType.AllSeries) {
                <app-side-nav-item cdkDrag cdkDragBoundary=".side-nav-container" cdkDragPreviewContainer="parent"
                                   [cdkDragDisabled]="!editMode" [cdkDragData]="navStream" [editMode]="editMode" icon="fa-regular fa-rectangle-list" [title]="t('all-series')" link="/all-series/" />
              }

              @case (SideNavStreamType.Bookmarks) {
                <app-side-nav-item cdkDrag cdkDragBoundary=".side-nav-container" cdkDragPreviewContainer="parent" [cdkDragDisabled]="!editMode"
                                   [cdkDragData]="navStream" [editMode]="editMode" icon="fa-bookmark" [title]="t('bookmarks')" link="/bookmarks/" />
              }

              @case (SideNavStreamType.ReadingLists) {
                <app-side-nav-item cdkDrag cdkDragBoundary=".side-nav-container" cdkDragPreviewContainer="parent"
                                   [cdkDragDisabled]="!editMode" [cdkDragData]="navStream" [editMode]="editMode"
                                   icon="fa-list-ol" [title]="t('reading-lists')" link="/lists/">
                  <ng-container actions>
                    <app-card-actionables [actions]="readingListActions" labelBy="reading-lists" iconClass="fa-ellipsis-v" (actionHandler)="performReadingListAction($event)" />
                  </ng-container>
                </app-side-nav-item>
              }

              @case (SideNavStreamType.Collections) {
                <app-side-nav-item cdkDrag cdkDragBoundary=".side-nav-container" cdkDragPreviewContainer="parent"
                                   [cdkDragDisabled]="!editMode" [cdkDragData]="navStream" [editMode]="editMode" icon="fa-list" [title]="t('collections')" link="/collections/" />
              }

              @case (SideNavStreamType.WantToRead) {
                <app-side-nav-item cdkDrag cdkDragBoundary=".side-nav-container" cdkDragPreviewContainer="parent"
                                   [cdkDragDisabled]="!editMode" [cdkDragData]="navStream" [editMode]="editMode" icon="fa-star" [title]="t('want-to-read')" link="/want-to-read/" />
              }

              @case (SideNavStreamType.BrowseAuthors) {
                <app-side-nav-item cdkDrag cdkDragBoundary=".side-nav-container" cdkDragPreviewContainer="parent"
                                   [cdkDragDisabled]="!editMode" [cdkDragData]="navStream" [editMode]="editMode" icon="fa-users" [title]="t('browse-people')" link="/browse/people/" />
              }

              @case (SideNavStreamType.SmartFilter) {
                <app-side-nav-item cdkDrag cdkDragBoundary=".side-nav-container" cdkDragPreviewContainer="parent"
                                   [cdkDragDisabled]="!editMode" [cdkDragData]="navStream" [editMode]="editMode" icon="fa-bars-staggered" [title]="navStream.name" [link]="getSmartFilterBaseLink(navStream)" [queryParams]="navStream.smartFilterEncoded" />
              }

              @case (SideNavStreamType.ExternalSource) {
                <app-side-nav-item [editMode]="editMode" icon="fa-server"
                                   cdkDrag cdkDragBoundary=".side-nav-container" cdkDragPreviewContainer="parent"
                                   [title]="navStream.name" [link]="navStream.externalSource.host + 'login' + (!!navStream.externalSource.apiKey ? '?apiKey=' + navStream.externalSource.apiKey : '')"
                                   [external]="true" />
              }

            }
          }

          @if (totalSize > ItemLimit && !showAll) {
            <app-side-nav-item icon="fa fa-chevron-right" [title]="t('more')" (click)="showMore()" />
          }
        }
      </div>
    </div>
  }

  @if (breakpointService.isTabletOrBelow()) {
    <div class="side-nav-overlay" (click)="toggleNavBar()" [class.closed]="sideNavCollapsed"></div>
  }

  <div class="sidenav-bottom" [class.closed]="sideNavCollapsed" [class.hidden]="!sideNavVisible || licenseService.hasValidLicense()">
    @if (!licenseService.hasValidLicense()) {
      <app-side-nav-item class="donate" icon="fa-heart"
                        [ngbTooltip]="t('donate-tooltip')"
                        [link]="WikiLink.Donation"
                        [external]="true" />
    }
  </div>

</ng-container>
